// Portuguese language pack
// Note: All keys are in Simplified Chinese, values are in Portuguese
// This design allows developers to use Chinese directly as keys for better understanding and maintenance

export default {
  // Computing Application Page - Computing.vue
  computing: {
    // Page titles and basic information
    '平台资产': 'Ativos da Plataforma',
    '质押金额': 'Valor de Hashrate',
    '算力周期': 'Período de Computação',
    '天': 'Dias',
    '算力类型': 'Tipo de Poder Computacional',
    '基础算力': 'Computing Básico',
    '高级算力': 'Computing Avançado',
    '超级算力': 'Super Computing',
    '企业算力': 'Computing Empresarial',
    '高性能': 'Alto Desempenho',
    '标准': 'Padrão',
    '经济型': 'Econômico',
    '申请算力': 'Solicitar Computing',
    '申请解押': 'Resgate de Hashrate',
    '可申请次数': 'Aplicações Disponíveis',
    '剩余次数': 'Vezes Restantes',
    '短算力类型': 'Tipo',
    '短算力周期': 'Periodo',
    '短预计日收益': 'Diario',
    '短剩余次数': 'Restam',
    '短解押记录': 'Resgate',
    '短算力记录': 'Leasing',
    '短质押明细': 'Hashrate',
    '短待审': 'Pendente',
    '短成功': 'Sucesso',
    '短失败': 'Falha',
    '短完成': 'Encerrado',
    '超级算力申请': 'Leasing de Hashrate',

    '步骤提示租赁': 'Passo 1 Selecione um plano de hashrate · Passo 2 Toque em "Leasing de Hashrate"',
    '请选择算力方案': 'Selecione um plano de hashrate',
    '请先选择算力方案': 'Selecione primeiro um plano de hashrate e depois toque em leasing',    '算力收益等级': 'Níveis de Rendimento Computing',
    '查看算力收益等级': 'Ver Níveis de Rendimento',
    '暂无高级算力等级数据': 'Nenhum dado de níveis de computing avançado disponível',
    '暂无超级算力等级数据': 'Nenhum dado de níveis de super computing disponível',

    // Página de Detalhes da Aplicação Computing
    '算力详情': 'Detalhes do Computing',
    '基本信息': 'Informações Básicas',
    '原押金额': 'Valor da Aposta Original',
    '每日收益记录': 'Registros de Ganhos Diários',
    '暂无数据': 'Nenhum Dado Disponível',

    // Computing details
    '算力类型标签': 'Tipo:',
    '算力周期标签': 'Período:',
    '算力类型：': 'Tipo:',
    '算力周期：': 'Período:',
    '预计收益：': 'Ganhos:',
    '质押要求：': 'Aposta:',
    '开始时间：': 'Início:',
    '结束时间：': 'Fim:',
    '立即申请': 'Aplicar',

    // Status and prompts
    '申请中...': 'Carregando...',
    '申请中': 'Carregando...',
    '申请成功': 'Bem-sucedido',
    '申请失败': 'Falhado',
    '申请失败，请重试': 'Aplicação falhou, tente novamente',
    '余额不足': 'Saldo Insuficiente',
    '请先连接钱包': 'Conectar Carteira',
    '算力申请成功！': 'Computing bem-sucedido!',
    '算力申请失败，请重试': 'Computing falhado, tentar novamente',
    '申请失败，请先解押已完成的算力订单': 'Falha na solicitação, desbloqueie primeiro o pedido de poder computacional concluído',
    
    // Confirmation dialog
    '确认申请': 'Confirmar Aplicação',
    '取消': 'Cancelar',
    '确认': 'Confirmar',
    '您确定要申请此算力吗': 'Solicitar este computing?',
    '您确定要申请此算力吗？': 'Solicitar este computing?',
    '申请后将扣除相应的质押金额': 'O valor será deduzido',
    
    // Computing status
    '运行中': 'Em Execução',
    '已完成': 'Concluído',
    '待开始': 'Pendente',
    '已取消': 'Cancelado',
    
    // Earnings related
    'USDC': 'USDC',
    '预计日收益': 'Ganhos Diários Esperados',
    '总预计收益': 'Ganhos Totais Esperados',
    '当前收益': 'Ganhos Atuais',
    
    // Records and status
    '解押申请记录': 'Registros de Resgate',
    '超级算力申请记录': 'Registros de Solicitação de Super Poder Computacional',
    '全部': 'Todos',
    '待审核': 'Pendente',
    '成功': 'Sucesso',
    '失败': 'Falhou',
    '正在加载记录': 'Carregando registros...',
    '暂无记录': 'Nenhum registro',
    '解押金额': 'Valor de Resgate',
    '申请天数': 'Dias de Solicitação',
    '金额': 'Valor',

    // Modal related
    '选择周期': 'Período Selecionado',
    '收益率': 'Taxa de Rendimento',
    '申请金额': 'Valor da Solicitação',
    '请输入申请金额': 'Por favor, insira o valor da solicitação',
    '最大可申请金额': 'Valor máximo aplicável',
    '投入限额': 'Limite de Investimento',
    '最低投入': 'Investimento Mínimo',
    '最大投入': 'Investimento Máximo',
    '短投入限额': 'Limite',
    '请输入有效的申请金额': 'Por favor, insira um valor de solicitação válido',
    '申请金额不能低于最低投入': 'O valor da solicitação não pode ser inferior ao investimento mínimo',
    '申请金额不能高于最大投入': 'O valor da solicitação não pode exceder o investimento máximo',

    // Error messages
    '网络错误，请稍后重试': 'Erro de rede, tente novamente mais tarde',
    '参数错误': 'Erro de parâmetro',
    '服务器错误': 'Erro do servidor',
    '未知错误': 'Erro desconhecido',
    '请输入有效金额': 'Por favor, insira um valor válido',
    '请输入大于0的解押金额': 'Por favor, insira um valor de desbloqueio maior que 0',
    '申请提交成功': 'Solicitação enviada com sucesso!',
    '您的解押申请已提交，请等待审核': 'Sua solicitação de desbloqueio foi enviada, aguarde a revisão',
    '申请提交失败': 'Falha no envio da solicitação',
    '请稍后重试': 'Tente novamente mais tarde',
    '您的账户余额不足，无法申请算力': 'Seu saldo da conta é insuficiente para solicitar poder computacional',
    '您的算力申请已提交，请等待审核': 'Sua solicitação de poder computacional foi enviada, aguarde a revisão',
    '登录已过期': 'Login expirado',
    '请重新连接钱包': 'Por favor, reconecte a carteira',
    '加载失败': 'Falha no carregamento',
    '无法获取解押申请记录': 'Não foi possível obter registros de solicitação de desbloqueio',
    '您还有待审核的申请，请等待审核完成后再提交新申请': 'Você tem uma solicitação pendente de revisão, aguarde a conclusão da revisão antes de enviar uma nova solicitação',
    '您还有未解押的算力订单，无法申请新的算力': 'Você tem uma ordem de poder computacional desbloqueada, não pode solicitar novo poder computacional',
    '申请次数已用完，最大申请次数': 'Limite de solicitações atingido, número máximo de solicitações',
    '没有可解押的金额': 'Nenhum valor disponível para desbloquear',
    '您已有待处理的解押申请，请等待审核': 'Você já tem uma solicitação de desbloqueio pendente, aguarde a revisão',

    '我的算力订单': 'Meus Pedidos de Hashrate',
    '总质押': 'Total em Staking',
    '总收益': 'Ganho Total',
    '进行中': 'Ativo',
    '剩余天数': 'Dias Restantes',
    '暂无算力订单': 'Sem pedidos de hashrate',

    // Popups relacionados à conexão da carteira
    '钱包未连接': 'Carteira não conectada',
    '钱包信息错误': 'Erro de informação da carteira',
    '钱包地址无效': 'Endereço de carteira inválido',
    '授权已失效': 'Autorização expirada',
    '授权检查失败': 'Verificação de autorização falhou',
    '请重新授权USDC后再进行投资': 'Por favor reautorize USDC antes de investir',
    '请稍后重试或重新连接钱包': 'Tente novamente mais tarde ou reconecte a carteira',
    '断开连接': 'Desconectar',
    '质押金额不足': 'Valor apostado insuficiente',
    '解押金额不能超过当前质押金额': 'O valor de desbloqueio não pode exceder o valor apostado atual',
    '需要连接钱包才能申请算力': 'Precisa conectar carteira para solicitar poder computacional',
    '需要连接钱包才能申请解押': 'Precisa conectar carteira para solicitar desbloqueio',

    // Mapeamento de texto de status
    '状态待审核': 'Pendente',
    '状态成功': 'Sucesso',
    '状态失败': 'Falhou',
    '状态进行中': 'Em Andamento',
    '状态已完成': 'Concluído',
    '状态已取消': 'Cancelado',
    '状态未知': 'Desconhecido',

    // Relacionado ao endereço da carteira
    '未连接钱包': 'Carteira não conectada',
    '地址格式错误': 'Formato de endereço inválido',

    // Atendimento ao cliente
    '客服功能开发中，敬请期待': 'O atendimento ao cliente está em desenvolvimento, fiquem atentos!',

    // Relacionado às configurações de poder computacional
    '设置错误': 'Erro de configuração',
    '未找到对应的算力设置': 'Configurações de poder computacional não encontradas',
    '无法获取算力设置': 'Não é possível obter configurações de poder computacional',

    // Relacionado ao desbloqueio (novo)
    '解押审核中': 'Desbloqueio em Revisão',
    '已解押': 'Desbloqueado',
    '确认解押': 'Confirmar Desbloqueio',
    '处理中': 'Processando...',
    '解押申请已提交': 'Solicitação de Desbloqueio Enviada',
    '请等待审核处理': 'Por favor aguarde a revisão',
    '解押申请失败': 'Falha na Solicitação de Desbloqueio',
    '当前状态不允许解押': 'O status atual não permite desbloqueio',

    // Relacionado aos detalhes de garantia (novo)
    '质押明细': 'Detalhes de Hashrate',
    '后值': 'Valor Posterior',
    '管理员操作': 'Operação do Sistema',
    '暂无质押记录': 'Sem registros de hashrate',
    '正在加载质押记录': 'Carregando registros de hashrate...',
    '获取质押记录失败': 'Falha ao obter registros de hashrate',
    '收益': 'Ganhos',
    '质押': 'Hashrate',
    '解押': 'Resgate',
    '充值': 'Depósito',
    '提现': 'Saque',
    '奖励': 'Recompensa',
    '推荐奖励': 'Recompensa de Indicação',
    '系统调整': 'Ajuste do Sistema',
    '算力收益': 'Ganhos de Computação',
    '机器人收益': 'Ganhos de Bot',

    // Mensagens de carregamento e erro (novo)
    '无法获取申请详情': 'Não é possível obter detalhes da solicitação',
    '请检查网络连接后重试': 'Por favor verifique a conexão de rede e tente novamente',
    '未找到可解押的算力申请': 'Nenhuma solicitação de poder computacional desbloqueável encontrada',

    // Relacionado ao status (novo)

    // Relacionado à página de detalhes (novo)
    '算力申请详情': 'Detalhes da Solicitação de Poder Computacional',
    '算力申请记录': 'Registros de Solicitações de Poder Computacional',
    '正在加载详情': 'Carregando detalhes...',
    '申请周期': 'Período da Solicitação',
    '申请时间': 'Tempo da Solicitação',
    '累计收益': 'Ganhos Totais',
    '暂无收益记录': 'Sem registros de ganhos',
    '加载失败请重试': 'Falha no carregamento, por favor tente novamente',
    '重新加载': 'Recarregar',
    '包含累计收益': 'incluindo ganhos totais',
    '解押后资金将退回到平台资产中不再产生收益': 'Após o desbloqueio, os fundos serão devolvidos aos ativos da plataforma e não gerarão mais ganhos.',
    '申请赎回': 'Resgatar Hashrate',
    '赎回金额': 'Valor do Resgate',
    '赎回审核中': 'Resgate em Análise',
    '未到期不可赎回': 'Não resgatável antes do vencimento',
    '暂不可赎回': 'Ainda Não Resgatável',
    '当前算力未到期': 'O hashrate atual não venceu, o resgate estará disponível após o vencimento',
    '需要连接钱包才能申请赎回': 'Precisa conectar a carteira para solicitar o resgate',
    '您的赎回申请已提交，请等待审核': 'Sua solicitação de resgate foi enviada, aguarde a análise',
    '确认赎回': 'Confirmar resgate',
    '已赎回': 'Resgatado',
    '您已有待处理的赎回申请，请等待审核': 'Você já tem uma solicitação de resgate pendente, aguarde a análise',
    '当前状态不允许赎回': 'O status atual não permite resgate',
    '没有可赎回的金额': 'Nenhum valor disponível para resgate'
  },

  // ==================== Página de Ativos - Assets.vue ====================
  assets: {
    // Ativos totais
    '总资产': 'Ativos Totais',

    // Visão geral da renda
    '总收入': 'Renda Total',
    '今日收入': 'Renda de Hoje',
    '体验金': 'Saldo de Demonstração',
    '空投奖励': 'Recompensas Airdrop',

    // Botões de ação
    '充值': 'Depósito',
    '快速充值说明': 'Deposite USDC rapidamente',
    '提现': 'Saque',
    '邀请': 'Convidar',
    '白皮书': 'Whitepaper',
    '幸运轮': 'Roda da Sorte',
    '站内信': 'Mensagens',
    '信用分': 'Pontuação de Crédito',
    '快捷邀请': 'Convidar',
    '快捷白皮书': 'Whitepaper',
    '快捷幸运轮': 'Sorte',
    '快捷信用分': 'Crédito',

    // Nível VIP
    'VIP等级': 'Nível VIP',
    '暂无VIP等级数据': 'Nenhum dado de nível VIP disponível',

    // Minha conta
    '我的账户': 'Minha Conta',
    '申请备用金': 'Solicitar Fundo de Reserva',
    '设置资金密码': 'Definir Senha de Fundos',
    '选择语言': 'Selecionar Idioma',

    // Mensagens de log do console
    '钱包未连接，触发钱包连接': 'Carteira não conectada, acionando conexão da carteira',
    '钱包地址无效，重新连接': 'Endereço da carteira inválido, reconectando',
    '钱包已连接，直接跳转到充值页面': 'Carteira conectada, redirecionando para página de depósito',
    '检查授权状态失败': 'Falha ao verificar status de autorização',
    '白皮书功能': 'Função whitepaper',
    '检查资金密码状态失败': 'Falha ao verificar status da senha de fundos',

    // Logs relacionados à API
    'Token不存在，显示默认余额': 'Token não existe, mostrando saldo padrão',
    '调用API获取用户余额数据': 'Chamando API para obter dados de saldo do usuário...',
    '体验金加载成功': 'Saldo de demonstração carregado com sucesso',
    '总资产计算完成': 'Cálculo de ativos totais concluído',
    '余额': 'Saldo',
    '质押金额': 'Valor de Hashrate',
    'API返回失败': 'API retornou falha',
    '加载用户余额失败': 'Falha ao carregar saldo do usuário',
    'Token不存在，显示默认收益': 'Token não existe, mostrando ganhos padrão',
    '调用API获取用户收益数据...': 'Chamando API para obter dados de ganhos do usuário...',
    '收益数据加载成功': 'Dados de ganhos carregados com sucesso',
    '收益API返回失败': 'API de ganhos retornou falha',
    '加载用户收益失败': 'Falha ao carregar ganhos do usuário',
    '使用默认收益数据': 'Usando dados de ganhos padrão',
    '信用分加载成功': 'Pontuação de crédito carregada com sucesso',
    '兑出': 'De',
    '兑入': 'Para',
    '确认闪兑': 'Confirmar troca',
    '闪兑记录': 'Historico de troca',
    '暂无闪兑记录': 'Ainda nao ha trocas',
    '不可与兑出/兑入相同币种': 'Nao pode ser a mesma moeda',
    '兑出与兑入不能是相同币种': 'Origem e destino nao podem ser a mesma moeda'
  },

  // ==================== Página de Recarga - Recharge.vue ====================
  recharge: {
    // Título da página e navegação
    '充值': 'Recarregar',
    '返回': 'Voltar',
    '充值记录': 'Histórico de Recarga',

    // Títulos dos passos
    '选择金额': 'Selecionar Valor',
    '确认订单': 'Confirmar Pedido',
    '完成转账': 'Completar Transferência',

    // Entrada de valor
    '请输入充值金额': 'Por favor, insira o valor da recarga',
    '自定义': 'Personalizado',
    '最小充值金额': 'Valor mínimo de recarga',
    '最小充值金额提示': 'Minimo de 500 USDC',
    '最大充值金额': 'Valor máximo de recarga',
    '下一步': 'Próximo',
    '上一步': 'Anterior',
    '开通自动转入': 'Ativar Transferência Automática',

    // Informações do pedido
    '订单信息': 'Informações do Pedido',
    '订单号': 'Número do Pedido',
    '充值金额': 'Valor da Recarga',
    '网络': 'Rede',
    '代币': 'Token',
    '收款地址': 'Endereço de Recebimento',
    '创建订单': 'Criar Pedido',
    '创建中': 'Criando...',

    // Conexão da carteira
    '请先连接钱包': 'Conecte a carteira primeiro',
    '未检测到钱包地址，请先连接钱包': 'Endereço da carteira não detectado, conecte a carteira primeiro',

    // Saldo
    'USDC余额不足': 'Saldo USDC insuficiente! Saldo atual',
    '转账超时，请检查钱包或重试': 'Timeout de transferência, verifique a carteira ou tente novamente',
    '转账成功但没有获得交易哈希，请手动提供交易哈希': 'Transferência bem-sucedida mas nenhum hash de transação recebido, forneça o hash de transação manualmente',
    '请先连接MetaMask钱包': 'Conecte a carteira MetaMask primeiro',
    '转账可能成功但无法获取交易哈希，请手动检查钱包': 'A transferência pode ter sido bem-sucedida mas não é possível obter o hash de transação, verifique a carteira manualmente',
    '交易哈希无效，请稍后在钱包历史中复制正确的交易哈希': 'Hash de transação inválido, copie o hash correto do histórico da carteira mais tarde',
    '钱包地址不存在': 'O endereço da carteira não existe',
    '交易失败': 'Transação falhou',
    '当前网络': 'Rede atual',
    '请切换到以太坊主网或测试网': 'Mude para a rede principal Ethereum ou testnet',
    '请点击页面右上角网络设置，选择Ethereum，然后重新充值。': 'Clique nas configurações de rede no canto superior direito da página, selecione Ethereum e recarregue novamente.',
    '需要': 'Necessário',
    '更新订单失败': 'Falha ao atualizar pedido',

    // Passos da transferência
    '请使用钱包转账': 'Por favor, use a carteira para transferir',
    '转账地址': 'Endereço de Transferência',
    '转账金额': 'Valor da Transferência',
    '合约地址': 'Endereço do Contrato',
    '复制地址': 'Copiar Endereço',
    '复制金额': 'Copiar Valor',
    '开始转账': 'Iniciar Transferência',
    '转账中': 'Transferindo...',
    '重新转账': 'Tentar Transferência Novamente',
    '查看详情': 'Ver Detalhes',

    // Informações de status
    '等待转账': 'Aguardando transferência',
    '确认中': 'Confirmando',
    '转账成功': 'Transferência bem-sucedida',
    '转账失败': 'Transferência falhada',
    '交易哈希': 'Hash da Transação',
    '在区块链浏览器中查看': 'Ver no explorador blockchain',

    // Dicas
    '请确保转账金额准确': 'Certifique-se de que o valor da transferência está correto',
    '请确保使用正确的网络': 'Certifique-se de usar a rede correta',
    '转账完成后系统会自动确认': 'O sistema confirmará automaticamente após a conclusão da transferência',
    '地址已复制': 'Endereço copiado',
    '金额已复制': 'Valor copiado',
    '复制失败': 'Falha ao copiar',

    // Mensagens de erro
    '金额不能为空': 'O valor não pode estar vazio',
    '金额必须大于': 'O valor deve ser maior que',
    '金额不能超过': 'O valor não pode exceder',
    '创建订单失败': 'Falha ao criar pedido',
    '转账失败，请重试': 'Transferência falhada, tente novamente',
    '网络错误，请检查连接': 'Erro de rede, verifique a conexão',

    // MetaMask相关
    '请安装MetaMask钱包': 'Por favor, instale a carteira MetaMask',
    '网络检查通过': 'Verificação de rede aprovada',
    'USDC余额不足！当前余额': 'Saldo USDC insuficiente! Saldo atual: {balance} USDC, necessário: {amount} USDC',
    '余额检查通过': '✅ Verificação de saldo aprovada',
    '余额检查失败': 'Verificação de saldo falhou',
    '开始执行转账': '🚀 Iniciando execução da transferência...',
    '请在MetaMask中确认交易': '⏳ Por favor, confirme a transação no MetaMask',
    '最终交易哈希': '✅ Hash de transação final',
    '交易哈希已保存到数据库': '✅ Hash de transação salvo no banco de dados',
    '保存哈希失败': '❌ Falha ao salvar hash',
    '转账发送失败': '❌ Falha no envio da transferência',
    '交易提交超时，请检查钱包交易记录或稍后重试': 'Timeout de submissão de transação, verifique os registros de transação da carteira ou tente novamente mais tarde',
    'Gas估算失败': 'Estimativa de Gas falhou',
    '交易哈希更新成功': '✅ Hash de transação atualizado com sucesso',
    '更新订单交易哈希失败': '❌ Falha ao atualizar hash de transação do pedido',
    '启动交易监控，订单号': '🔄 Iniciando monitoramento de transação, número do pedido',
    '检查交易状态': '🔍 Verificando status da transação...',
    '订单状态响应': '📊 Resposta do status do pedido',
    '订单详情': '📋 Detalhes do pedido',
    '交易成功': '✅ Transação bem-sucedida!',
    '交易还在确认中，状态': '⏳ Transação ainda em confirmação, status',
    'API响应失败': '❌ Resposta da API falhou',
    '检查交易状态失败': 'Verificação do status da transação falhou',
    '转账状态已重置': '🔄 Status da transferência redefinido',

    // Atendimento ao cliente
    '客服功能开发中，敬请期待': 'Função de atendimento ao cliente em desenvolvimento, fique ligado!',

    // Níveis de taxa de poder computacional
    '查看算力收益等级': 'Ver níveis de taxa de computação',
    '算力收益等级': 'Níveis de taxa de poder computacional',
    '暂无算力收益等级数据': 'Nenhum dado de níveis de taxa de computação disponível',
    '获取算力收益等级失败': 'Falha ao obter os níveis de taxa de computação',
    '日收益率': 'Taxa diária'
  },

  // ==================== Página de Histórico de Recarga - RechargeHistory.vue ====================
  rechargeHistory: {
    '充值记录': 'Histórico de Recarga',
    '全部': 'Todos',
    '待支付': 'Aguardando Pagamento',
    '待审核': 'Aguardando Revisão',
    '确认中': 'Confirmando',
    '成功': 'Sucesso',
    '失败': 'Falhado',
    '已完成': 'Concluído',
    '已取消': 'Cancelado',
    '暂无记录': 'Sem registros',
    '加载中': 'Carregando...',
    '加载更多': 'Carregar Mais',
    '没有更多数据': 'Não há mais dados',
    '暂无充值记录': 'Sem registros de recarga',
    '立即充值': 'Recarregar Agora',
    '充值': 'Recarga',
    '订单号': 'Número do Pedido',
    '筛选': 'Filtro',
    '记录': 'Registros',
    '总充值': 'Recarga Total',
    '刚刚': 'Agora mesmo',
    '分钟前': ' minutos',
    '小时前': ' horas'
  },

  // ==================== Página de Detalhes de Recarga - RechargeDetail.vue ====================
  rechargeDetail: {
    '充值详情': 'Detalhes da Recarga'
  ,

    // 新增翻译键
    '加载中': 'Carregando',
    '订单不存在或已删除': 'O pedido não existe ou foi excluído',
    '返回': 'Voltar',
    '订单信息': 'Informações do pedido',
    '订单号': 'Número do pedido',
    '充值网络': 'Rede de recarga',
    '支付时间': 'Hora do pagamento',
    '确认时间': 'Hora de confirmação',
    '转账信息': 'Informações de transferência',
    '充值地址': 'Endereço de recarga',
    '复制': 'Copiar',
    '交易哈希': 'Hash da transação',
    '确认进度': 'Progresso de confirmação',
    '确认': 'Confirmação',
    '查看区块浏览器': 'Ver explorador de blocos',
    '取消订单': 'Cancelar pedido'
  },

  // ==================== Página de Saque - Withdrawal.vue ====================
  withdrawal: {
    // Título da página e navegação
    '提现': 'Saque',
    '返回': 'Voltar',
    '提现记录': 'Histórico de Saques',

    // Exibição de saldo
    '我的提现账户余额': 'Saldo da Minha Conta de Saque',
    '可提现余额': 'Saldo Disponível',
    '当前可提取余额': 'Saldo Disponível Atual',
    '信用分': 'Crédito',

    // Campos do formulário
    '提现金额': 'Valor do Saque',
    '请输入提现金额': 'Por favor, insira o valor do saque',
    '请输入自定义提款金额': 'Por favor, insira um valor personalizado',
    '最大限度': 'Máx',
    '提现地址': 'Endereço de Saque',
    '请输入提现地址': 'Por favor, insira o endereço de saque',
    '提现密码': 'Senha de Saque',
    '请输入提现密码': 'Por favor, insira a senha de saque',
    '资金密码': 'Senha de Fundos',
    '请输入资金密码': 'Por favor, insira a senha de fundos',
    '显示密码': 'Mostrar Senha',
    '隐藏密码': 'Ocultar Senha',

    // Regras de saque
    '提款规则': 'Regras de Saque',
    '提现规则': 'Regras de Saque',
    '手续费': 'Taxa',
    '单笔范围': 'Faixa por transação',
    '提现手续费': 'Taxa de Saque',
    '提现金额范围': 'Faixa de Valor de Saque',
    '资金将在1-24小时内到账': 'Os fundos chegarão em 1-24 horas',
    '手续费率': 'Taxa de Comissão',
    '最小提现金额': 'Saque Mínimo',
    '最大提现金额': 'Saque Máximo',
    '预计到账时间': 'Tempo de Chegada Esperado',
    '工作日内处理': 'Processado em dias úteis',

    // Botões e ações
    '确认提款': 'Confirmar Saque',
    '处理中': 'Processando',
    '提交申请': 'Enviar Solicitação',
    '设置资金密码': 'Definir Senha de Fundos',
    '忘记密码？': 'Esqueceu a Senha?',
    '取消': 'Cancelar',
    '去设置': 'Ir para Configurações',

    // Avisos modais
    '需要设置资金密码': 'Precisa Definir Senha de Fundos',
    '为了您的资金安全，请先设置资金密码': 'Para a segurança dos seus fundos, defina primeiro a senha de fundos',

    // Mensagens de sucesso
    '申请提交成功': 'Solicitação Enviada com Sucesso',
    '您的提现申请已提交，请等待审核': 'Sua solicitação de saque foi enviada, aguarde a revisão',
    '提现申请已提交': 'Solicitação de saque enviada',
    '请等待审核': 'Aguarde a revisão',

    // Mensagens de erro
    '申请提交失败': 'Falha no Envio da Solicitação',
    '提现申请失败': 'Falha na solicitação de saque',
    '请稍后重试': 'Tente novamente mais tarde',
    '余额不足': 'Saldo Insuficiente',
    '金额格式错误': 'Formato de valor inválido',
    '地址格式错误': 'Formato de endereço inválido',
    '资金密码错误': 'Senha de fundos incorreta',
    '您还有待处理的提现申请，请等待处理完成后再提交新申请': 'Você tem uma solicitação de saque pendente, aguarde o processamento antes de enviar uma nova',
    '信用分不足': 'Pontuação de Crédito Insuficiente',
    '信用分不足无法提款': 'Pontuação de crédito insuficiente, não é possível sacar',
    '您有待还款订单，请还款后申请提现': 'Você tem pedidos de empréstimo pendentes. Por favor, pague antes de solicitar um saque!',

    // Mensagens do sistema e logs
    '用户提现申请': 'Solicitação de saque do usuário',
    '加载用户数据失败': 'Falha ao carregar dados do usuário',
    '检查资金密码状态失败': 'Falha ao verificar status da senha de fundos'
  },



  // ==================== Modal de Convite - InviteModal.vue ====================
  invite: {
    '邀请好友一起赚币': 'Convide amigos para ganhar juntos',
    '复制邀请码': 'Copiar código de convite',
    '朋友扫二维码注册加入': 'Amigos escaneiam o código QR para se registrar',
    '邀请链接': 'Link de convite',
    '加载邀请数据失败': 'Erro ao carregar dados do convite',
    '加载失败': 'Carregamento falhou',
    '获取邀请信息失败，请稍后重试': 'Erro ao obter info do convite, tente novamente mais tarde',
    '生成二维码失败': 'Erro ao gerar código QR',
    '邀请码已复制': 'Código de convite copiado',
    '邀请链接已复制': 'Link de convite copiado',
    '复制失败': 'Falha ao copiar',
    '请手动复制': 'Copie manualmente'
  },

  // ==================== Página Roda da Fortuna - LuckyWheel.vue ====================
  luckyWheel: {
    '幸运轮': 'Roda da Fortuna',
    '页面副标题': 'Sorteio em grelha · sequência luminosa',
    '剩余': 'Restantes',
    '次': 'vezes',
    '奖金': 'Prêmio',
    '抽奖': 'Sortear',
    '奖品': 'Prêmio',
    '暂无中奖记录': 'Sem registros de premio',
    '总抽奖次数': 'Sorteios Totais',
    '抽奖次数不足': 'Sorteios insuficientes',
    '提示': 'Aviso',
    '抽奖失败': 'Sorteio falhou',
    '网络错误': 'Erro de rede',
    '网络错误，请重试': 'Erro de rede, tente novamente',
    '中奖时间': 'Hora do Prêmio',
    '中奖金额': 'Valor Ganho',
    '状态': 'Status',
    '暂无数据': 'Sem dados',
    '待发放': 'Pendente',
    '已发放': 'Distribuído',
    '发放失败': 'Falhado',
    '恭喜中奖': 'Parabéns!',
    '确定': 'OK'
  },

  // ==================== Página Solicitar Fundos - ApplyFunds.vue ====================
  applyFunds: {
    '申请备用金': 'Solicitar Fundos',
    '经平台审核，您可向平台申请一笔借款': 'Após revisão da plataforma, você pode solicitar um empréstimo',
    '借贷产品': 'Produto de Empréstimo',
    '请选择产品': 'Selecione o produto',
    '借款金额': 'Valor do Empréstimo',
    '输入借款金额': 'Digite o valor do empréstimo',
    '还款周期': 'Período de Pagamento',
    '请输入还款周期': 'Digite o período de pagamento',
    '天': 'dias',
    '日利率': 'Taxa Diária',
    '利息': 'Juros',
    '还款方式': 'Método de Pagamento',
    '免款服务由AI Agents提供，请通过外部资金偿还': 'Serviço gratuito fornecido por HamiltonLane, pague com fundos externos',
    '免款服务由HamiltonLane提供，请通过外部资金偿还': 'Serviço gratuito fornecido por HamiltonLane, pague com fundos externos',
    '放款机构': 'Instituição Credora',
    '借款规则': 'Regras do Empréstimo',
    '下一步': 'Próximo',
    '姓名': 'Nome',
    '手机号': 'Telefone',
    '证件上传': 'Upload de Documentos',
    '身份证正面': 'Frente do RG',
    '身份证反面': 'Verso do RG',
    '点击上传': 'Clique para Enviar',
    '重新上传': 'Enviar Novamente',
    '上传成功': 'Upload Bem-sucedido',
    '上传失败': 'Falha no Upload',
    '请上传身份证正面': 'Por favor, envie a frente do RG',
    '请上传身份证反面': 'Por favor, envie o verso do RG',
    '请输入': 'Digite',
    '提交中': 'Enviando...',
    '确定': 'Confirmar',
    '请选择图片文件': 'Selecione um arquivo de imagem',
    '文件大小不能超过10MB': 'O tamanho do arquivo nao pode exceder 10MB',
    '恭喜您申请成功': 'Parabéns pela solicitação bem-sucedida',
    '您的借款已申请成功，待平台审核成功放款': 'Sua solicitação de empréstimo foi bem-sucedida, aguardando aprovação da plataforma',
    '选择借贷产品': 'Selecionar Produto de Empréstimo',

    // Mensagens de erro
    '申请失败': 'Solicitação Falhou',
    '申请失败，请重试': 'Solicitação falhou, tente novamente',

    // Traduções de nomes de produtos
    '产品名称': {
      '快速借贷': 'Empréstimo Rápido',
      '标准借贷': 'Empréstimo Padrão',
      '长期借贷': 'Empréstimo de Longo Prazo',
      '小额借贷': 'Microempréstimo',
      '大额借贷': 'Empréstimo de Grande Valor',
      '短期借贷产品': 'Produto de Empréstimo de Curto Prazo'
    },

    // Traduções de descrições de produtos
    '产品描述': {
      '适合短期资金周转的借贷产品，利率优惠，审核快速': 'Adequado para rotatividade de capital de curto prazo, taxas de juros preferenciais, aprovação rápida'
    },

    // Traduções de mensagens da API
    'API消息': {
      '获取借贷产品成功': 'Produtos de empréstimo recuperados com sucesso'
    }
  },

  // ==================== Página Registros de Empréstimos - LoanRecords.vue ====================
  loanRecords: {
    '借款记录': 'Registros de Empréstimos',
    '借贷中心': 'Centro de Emprestimos',
    '总记录': 'Total de Registros',
    '总借款': 'Total Emprestado',
    '进行中': 'Em andamento',
    '全部': 'Todos',
    '加载中': 'Carregando',
    '没有更多数据了': 'Não há mais dados',
    '借款': 'Empréstimo',
    '借款金额': 'Valor do Empréstimo',
    '还款周期': 'Período de Pagamento',
    '天': 'dias',
    '日利率': 'Taxa Diária',
    '利息': 'Juros',
    '还款方式': 'Método de Pagamento',
    '免款服务由AI Agents提供，请通过外部资金偿还': 'Serviço gratuito fornecido por HamiltonLane, pague com fundos externos',
    '免款服务由HamiltonLane提供，请通过外部资金偿还': 'Serviço gratuito fornecido por HamiltonLane, pague com fundos externos',
    '放款机构': 'Instituição Credora',
    '待审核': 'Pendente',
    '已通过': 'Aprovado',
    '审核成功': 'Aprovado',
    '已驳回': 'Rejeitado',
    '审核失败': 'Rejeitado',
    '已还款': 'Reembolsado',
    '已逾期': 'Vencido',
    '逾期': 'Vencido',
    '未知状态': 'Status Desconhecido'
  },

  // ==================== Página Definir Senha de Fundos - SetFundPassword.vue ====================
  setFundPassword: {
    '设置资金密码': 'Definir Senha de Fundos',
    '安全中心': 'Centro de Seguranca',
    '密码长度至少6位': 'A senha deve ter pelo menos 6 caracteres',
    '密码长度不超过20位': 'A senha não deve exceder 20 caracteres',
    '确认密码': 'Confirmar Senha',
    '两次输入的密码一致': 'As senhas coincidem',
    '设置中': 'Definindo...',
    '确定': 'Confirmar',

    // Mensagens de resposta da API
    '参数验证失败': 'Falha na validação de parâmetros',
    '您已设置过资金密码，如需修改请联系客服': 'Você já definiu uma senha de fundos. Entre em contato com o atendimento ao cliente para modificá-la',
    '资金密码设置成功': 'Senha de fundos definida com sucesso',
    '设置失败': 'Falha na definição',
    '获取状态失败': 'Falha ao obter status',

    // Mensagens de prompt frontend
    '设置成功': 'Definido com sucesso',
    '请稍后重试': 'Tente novamente mais tarde',
    '设置资金密码失败': 'Falha ao definir senha de fundos'
  },

  // ==================== Página Modificar Senha de Fundos - ModifyFundPassword.vue ====================
  modifyFundPassword: {
    // Título da página
    '修改资金密码': 'Modificar Senha de Fundos',
    '修改安全密码': 'Modificar Senha de Segurança',
    '返回': 'Voltar',

    // Exibição de status
    '已设置资金密码': 'Senha de fundos definida',

    // Campos do formulário
    '原密码': 'Senha Atual',
    '请输入原密码': 'Digite a senha atual',
    '新密码': 'Nova Senha',
    '请输入新密码': 'Digite a nova senha',
    '确认新密码': 'Confirmar Nova Senha',
    '请再次输入新密码': 'Digite novamente a nova senha',

    // Botões e ações
    '确认修改': 'Confirmar Modificação',
    '修改中': 'Modificando...',
    '忘记原密码': 'Esqueceu a senha atual?',
    '忘记安全密码': 'Esqueceu a senha de segurança?',
    '联系客服': 'Contatar Suporte',
    '取消': 'Cancelar',

    // Dicas
    '原密码不能为空': 'A senha atual não pode estar vazia',
    '原密码错误': 'Senha atual incorreta',
    '新密码不能与原密码相同': 'A nova senha não pode ser igual à atual',
    '密码修改成功': 'Senha modificada com sucesso',
    '密码修改失败': 'Falha ao modificar a senha',
    '如需重置安全密码，请联系客服人员协助处理': 'Para redefinir sua senha de segurança, entre em contato com o atendimento ao cliente para assistência',

    // Mensagens de resposta da API
    '参数验证失败': 'Falha na validação de parâmetros',
    '您尚未设置资金密码': 'Você ainda não definiu uma senha de fundos',
    '资金密码修改成功': 'Senha de fundos modificada com sucesso',
    '修改失败': 'Falha na modificação',

    // Mensagens de prompt frontend
    '修改安全密码失败': 'Falha ao modificar senha de segurança',
    '请稍后重试': 'Tente novamente mais tarde'
  ,

    // 新增翻译键
    '密码长度6-20位': 'Comprimento da senha 6-20 caracteres',
    '两次输入的密码一致': 'As senhas coincidem'
  },

  // ==================== Página Investimento Robot - RobotInvestment.vue ====================
  robotInvestment: {
    // Título da página
    '详情': 'Detalhes',
    '返回': 'Voltar',

    // Informações de compra
    '申购金额': 'Valor da compra',
    '购买金额': 'Valor da compra',
    '最大': 'Máx',
    '最小限额': 'Limite mínimo',
    '最大限额': 'Limite máximo',
    '日收益率': 'Taxa de retorno diário',
    '周期': 'Período',
    '天': 'Dias',

    // Informações de saldo
    '可用余额': 'Saldo disponível',
    '可购次数': 'Número de compras',

    // Botões e status
    '处理中': 'Processando',
    '申购': 'Comprar',
    '余额错误': 'Erro de saldo',
    '无法获取有效的余额信息': 'Nao foi possivel obter saldo valido',
    '输入错误': 'Erro de entrada',
    '请输入申购金额': 'Digite o valor da compra',
    '请输入有效的申购金额': 'Digite um valor de compra valido',
    '钱包未连接': 'Carteira nao conectada',
    '请先连接钱包': 'Conecte a carteira primeiro',
    '钱包信息错误': 'Erro nas informacoes da carteira',
    '请重新连接钱包': 'Reconecte a carteira',
    '钱包地址无效': 'Endereco de carteira invalido',
    '授权已失效': 'Autorizacao expirada',
    '请重新授权USDC后再进行投资': 'Reautorize USDC antes de investir',
    '授权检查失败': 'Falha na verificacao de autorizacao',
    '请稍后重试或重新连接钱包': 'Tente mais tarde ou reconecte a carteira',
    '金额不足': 'Valor abaixo do minimo',
    '申购金额不能少于': 'O valor da compra nao pode ser menor que',
    '金额超限': 'Valor acima do limite',
    '申购金额不能超过': 'O valor da compra nao pode exceder',
    '余额不足': 'Saldo insuficiente',
    '您的可用余额为': 'Seu saldo disponivel e',
    '无法完成此次申购': 'nao e possivel concluir esta compra',
    '申购成功': 'Compra realizada',
    '订单号': 'Numero do pedido',
    '申购失败': 'Falha na compra',
    '申购失败，请稍后重试': 'Falha na compra, tente novamente mais tarde',
    '网络错误，请稍后重试': 'Erro de rede, tente novamente mais tarde'
  },

  flashOptions: {
    '闪电期权': 'Opções Flash',
    '请先连接钱包': 'Por favor, conecte a carteira',
    '连接钱包后即可开始闪电期权交易': 'Conecte sua carteira para iniciar a negociação de opções flash',
    '连接钱包': 'Conectar carteira',
    '加载中': 'Carregando...',
    '暂无可交易资产': 'Nenhum ativo negociável',
    '请稍后再试': 'Tente novamente mais tarde',
    '时间': 'Tempo',
    '金额': 'Valor',
    '回报额': 'Retorno',
    '利润': 'Lucro',
    '当前持仓': 'Posições abertas',
    '暂无持仓': 'Nenhuma posição',
    '买涨': '▲ Alta',
    '买跌': '▼ Baixa',
    '开仓': 'Abertura',
    '入场价': 'Preço entrada',
    '出场价': 'Preço saída',
    '收益率': 'Retorno',
    '投入': 'Valor',
    '入场时间': 'Hora entrada',
    '出场时间': 'Hora saída',
    '实时价': 'Preço ao vivo',
    '倒计时': 'Contagem regressiva',
    '交易记录': 'Histórico',
    '暂无记录': 'Sem registros',
    '涨': 'Alta',
    '跌': 'Baixa',
    '秒': 's',
    '分钟': 'min',
    '结算中': 'Liquidando...',
    '加载配置失败': 'Falha ao carregar',
    '请完善交易信息': 'Preencha as informações',
    '下单失败': 'Falha no pedido',
    '买涨成功': 'Compra alta com sucesso',
    '买跌成功': 'Compra baixa com sucesso',
    '确认下单': 'Confirmar ordem',
    '交易对': 'Par',
    '交易模式': 'Modo',
    '预计回报': 'Retorno est.',
    '预计利润': 'Lucro est.',
    '取消': 'Cancelar',
    '确认': 'Confirmar',
    '提交中': 'Enviando…',
    '等待行情数据': 'Aguardando dados de mercado...',
    '余额不足': 'Saldo insuficiente',
    '资产不可用': 'Ativo indisponível',
    '周期不可用': 'Período indisponível',
    '智能交易': 'Trading IA',
    '交易标的': 'Ativo',
    '风险类型': 'Tipo de risco',
    '投入金额': 'Valor',
    '提交申请': 'Enviar',
    '我的AI订单': 'Minhas ordens IA',
    '稳健型': 'Conservador',
    '平衡型': 'Equilibrado',
    '进取型': 'Agressivo',
    '稳健': 'Seguro',
    '平衡': 'Equilibrado',
    '进取': 'Agressivo',
    '低风险低回报适合稳健投资者': 'Baixo risco, baixo retorno. Para investidores conservadores.',
    '中等风险中等回报适合大多数投资者': 'Risco médio, retorno médio. Para a maioria dos investidores.',
    '高风险高回报适合激进投资者': 'Alto risco, alto retorno. Para investidores agressivos.',
    '待审核': 'Pendente',
    '运行中': 'Em execução',
    '已停止': 'Parado',
    '已结算': 'Liquidado',
    '已驳回': 'Rejeitado',
    'AI剩余': 'Restante',
    'AI做单': 'Operações',
    'AI笔': '',
    'AI胜': 'V',
    'AI负': 'D',
    '请先选择交易标的': 'Selecione um ativo primeiro',
    '请输入有效金额': 'Insira um valor válido',
    'AI交易申请已提交': 'Pedido IA enviado, aguardando revisão',
    'AI提交失败': 'Falha ao enviar',
    '停止交易': 'Parar',
    '确认停止AI交易': 'Parar o trading AI? Os fundos restantes serão reembolsados.',
    '停止失败': 'Falha ao parar',
    '确认取消AI申请': 'Cancelar esta solicitação AI? Os fundos congelados serão reembolsados.',
    '取消失败': 'Falha ao cancelar',
    '体验金': 'Demo',
    '体验金不足': 'Saldo de demonstração insuficiente',
    '可用余额': 'Disp.',
    '累计盈亏': 'PnL',
  },

  // ==================== Navegação Inferior - BottomNavigation.vue ====================
  bottomNav: {
    '首页': 'Início',
    '投资': 'Investir',
    '闪期权': 'Flash',
    '算力申请': 'Hashrate',
    '资产': 'Ativos'
  },

  // ==================== Registros de Mudança de Saldo - BalanceLogs.vue ====================
  balanceLogs: {
    '账变记录': 'Registros de Mudança de Saldo',
    '总收入': 'Receita Total',
    '总支出': 'Despesas Totais',
    '净收益': 'Lucro Líquido',
    '记录总数': 'Total de Registros',
    '全部': 'Todos',
    '用户充值': 'Recarga do Usuário',
    '管理操作': 'Operação do Sistema',
    '用户提现': 'Saque do Usuário',
    '借贷': 'Emprestimo',
    '借贷到账': 'Emprestimo Creditado',
    '算力申请': 'Aplicação de Computação',
    '机器人收益': 'Ganhos do Robô',
    '算力收益': 'Ganhos de Computação',
    '空投': 'Airdrop',
    '幸运轮': 'Roda da Fortuna',
    '闪期权': 'Opções Flash',
    '加载中': 'Carregando',
    '暂无记录': 'Sem Registros',
    '暂无账变记录': 'Nenhum registro de mudança de saldo',
    '余额变化': 'Mudança de Saldo',
    '加载更多': 'Carregar Mais',
    '记录详情': 'Detalhes do Registro',
    '业务类型': 'Tipo de Negócio',
    '操作类型': 'Tipo de Operação',
    '变动金额': 'Valor da Mudança',
    '变动前余额': 'Saldo Antes da Mudança',
    '变动后余额': 'Saldo Após a Mudança',
    '变动原因': 'Motivo da Mudança',
    '备注': 'Observações',
    '状态': 'Status',
    '交易哈希': 'Hash da Transação',
    '创建时间': 'Tempo de Criação',
    '处理时间': 'Tempo de Processamento',
    '刚刚': 'Agora mesmo',
    '分钟前': 'minutos atrás',
    '小时前': 'horas atrás',
    '关闭': 'Fechar',
    '没有更多记录': 'Não Há Mais Registros',

    // Tipos de Negócio (algumas chaves existem em outros lugares, comentadas para evitar duplicatas)
    // '充值': 'Recarga',
    // '提现': 'Saque',
    // '算力申请': 'Poder de Computação', // Chave duplicada, já definida em outro lugar
    'AI机器人': 'Robô IA',
    '解押': 'Resgate',
    '管理员操作': 'Operação do Sistema',
    '推荐佣金': 'Comissão de Indicação',
    // '奖励': 'Recompensa',
    '幸运轮盘': 'Roda da Sorte',
    '其他': 'Outro',

    // Status
    '待审核': 'Pendente de Revisão',
    '处理中': 'Em Processamento',
    '待处理': 'Pendente',
    '已完成': 'Concluído',
    '失败': 'Falhado',
    '已取消': 'Cancelado',

    // Tipos de Ação
    '增加': 'Adicionar',
    '减少': 'Subtrair',
    '设置': 'Definir',

    // Tipos de Conta
    '余额变动': 'Mudança de Saldo',
    '质押变动': 'Mudança de Stake',

    // Traduções de Motivo
    'reason_recharge_arrived': 'Recarga Chegou',
    'reason_withdrawal_apply': 'Solicitação de Saque, Saldo Congelado',
    'reason_withdrawal_rejected': 'Solicitação de Saque Rejeitada, Saldo Congelado Devolvido',
    'reason_withdrawal_success': 'Saque Bem-sucedido',
    'reason_computing_apply': 'Solicitação de Poder de Computação, Saldo Congelado',
    'reason_unstake_success': 'Desbloqueio Bem-sucedido, Stake Descongelado para Saldo',
    'reason_computing_earning': 'Ganhos de Poder de Computação Chegaram',
    'reason_computing_unstake': 'Desbloqueio de Poder de Computação Expirado',
    'reason_robot_invest': 'Investimento em Robô IA',
    'reason_robot_earning': 'Ganhos do Robô Chegaram',
    'reason_loan_credit': 'Emprestimo aprovado creditado',
    'reason_unstake_approved': 'Solicitação de Desbloqueio Aprovada',
    'reason_referral_commission': 'Comissão de Indicação Chegou',
    'reason_lucky_wheel_reward': 'Recompensa do Prêmio da Roda da Sorte',
    'reason_airdrop': 'Recompensa Airdrop',
    'reason_reward': 'Distribuição de Recompensa',
    'reason_airdrop_issue': 'Distribuição de Airdrop',
    'reason_flash_option_buy': 'Ordem de Opção Flash',
    'reason_flash_option_win': 'Lucro de Opção Flash',
    'reason_flash_option_draw': 'Reembolso Empate Opção Flash',
    'reason_flash_option_lose': 'Perda de Opção Flash',
    'reason_demo_flash_option_buy': 'Demo Flash Option Order',
    'reason_demo_flash_option_win': 'Demo Flash Option Profit',
    'reason_demo_flash_option_draw': 'Demo Flash Option Draw Refund',
    'reason_demo_flash_option_lose': 'Demo Flash Option Loss',
    'reason_ai_flash_option_buy': 'AI Flash Option Order',
    'reason_ai_flash_option_win': 'AI Flash Option Profit',
    'reason_ai_flash_option_draw': 'AI Flash Option Draw Refund',
    'reason_ai_flash_option_lose': 'AI Flash Option Loss',

    // Traduções de Observação
    'remark_recharge_order': 'Pedido de Recarga',
    'remark_withdrawal_order': 'Pedido de Saque',
    'remark_application_rejected': 'Solicitação Rejeitada',
    'remark_transaction_hash': 'Hash da Transação',
    'remark_computing_application': 'Solicitação de Computação',
    'remark_unstake_application': 'Solicitação de Desbloqueio',
    'remark_robot_order': 'Pedido de Robô',
    'remark_lucky_wheel_reward': 'Recompensa da Roda da Sorte',
    'remark_robot_earning': 'Ganhos do Robô',
    'remark_computing_earning': 'Ganhos de Computação',
    'remark_computing_earning_to_stake': 'Ganhos de Computação Adicionados ao Stake',
    'remark_flash_option_buy': 'Ordem de Opção Flash',
    'remark_flash_option_win': 'Lucro de Opção Flash',
    'remark_flash_option_draw': 'Reembolso Empate Opção Flash',
    'remark_flash_option_lose': 'Perda de Opção Flash',
    'remark_demo_flash_option_buy': 'Demo Flash Option Order',
    'remark_demo_flash_option_win': 'Demo Flash Option Profit',
    'remark_demo_flash_option_draw': 'Demo Flash Option Draw Refund',
    'remark_demo_flash_option_lose': 'Demo Flash Option Loss',
    'remark_ai_flash_option_buy': 'AI Flash Option Order',
    'remark_ai_flash_option_win': 'AI Flash Option Profit',
    'remark_ai_flash_option_draw': 'AI Flash Option Draw Refund',
    'remark_ai_flash_option_lose': 'AI Flash Option Loss',
    'remark_airdrop_issue': 'Distribuição de Airdrop',

    '闪期权下单': 'Ordem de Opção Flash',
    '闪期权盈利': 'Lucro de Opção Flash',
    '闪期权平局': 'Empate de Opção Flash',
    '闪期权亏损': 'Perda de Opção Flash',
    '模拟闪期权下单': 'Demo Flash Option Order',
    '模拟闪期权盈利': 'Demo Flash Option Profit',
    '模拟闪期权平局': 'Demo Flash Option Draw',
    '模拟闪期权亏损': 'Demo Flash Option Loss',
    '空投发放': 'Distribuição de Airdrop',
    '算力收益发放': 'Distribuição de Rendimentos de Cálculo',
    '奖励发放': 'Distribuição de Recompensas',
    '成功': 'Sucesso',
    '资产中心': 'Centro de ativos',
    '筛选': 'Filtrar',
    '更多类型': 'Mais tipos',
    '金额方向': 'Direção do valor',
    '流入': 'Entrada',
    '流出': 'Saída',
    '关键词': 'Palavra-chave',
    '搜索类型原因备注': 'Buscar tipo/motivo/observação',
    '重置': 'Redefinir',
    '完成': 'Concluir',
    '当前筛选': 'Filtro atual',
    '记录条数': 'Registros',
    '净额': 'Líquido',
    '点击查看详情': 'Toque para ver detalhes',
    '账变记录页面已加载': 'Página de registros de saldo carregada'
  },

  // ==================== Página Inicial - Home.vue ====================
  home: {
    // Conteúdo Principal
    'titleLine1': 'HamiltonLane',
    'titleLine2': 'Private Markets. Professional Allocation.',
    'mainTitle': 'HamiltonLane: Private Markets Investment Solutions',
    'mainDescription': 'We partner with clients to conceive, build, establish, manage, and monitor private market fund and direct investment portfolios—helping every investor access quality opportunities worldwide.',
    'heroIntro': 'A professional investment platform built for high-net-worth clients',
    'heroPoint1': 'Private markets expertise across funds and direct investments',
    'heroPoint2': 'Global opportunity access for diversified private market exposure',
    'heroPoint3': 'Institutional process from conception through ongoing monitoring',
    'startJoining': 'Get Started',
    'walletConnected': 'Wallet conectada',
    'walletNotConnected': 'Wallet nao conectada',
    'heroMarketTag': 'Private Markets',

    // Seção de Investimento
    'investmentTitle': 'Investment Solutions',
    'investmentSubtitle': 'End-to-end partnership across the private markets lifecycle',

    // Conteúdo das Categorias
    'category1Title': 'Portfolio Conception & Strategy',
    'category1Short': 'Align objectives, risk appetite, and allocation themes for private markets.',
    'category1Full': 'We work closely with clients to clarify goals and liquidity needs, then design a clear private markets blueprint across private equity, credit, real estate, and infrastructure.',

    'category2Title': 'Fund & Direct Investment Build',
    'category2Short': 'Help structure private market funds and construct direct investment portfolios.',
    'category2Full': 'From opportunity screening and diligence to portfolio construction, we support disciplined allocation decisions that balance diversification and long-term return potential.',

    'category3Title': 'Global Opportunity Access',
    'category3Short': 'Help investors reach private market opportunities around the world.',
    'category3Full': 'Through a global private markets network, we connect clients to opportunities across regions and strategies, lowering access barriers for high-net-worth investors.',

    'category4Title': 'Portfolio Management',
    'category4Short': 'Continuously manage funds and direct investments with performance tracking.',
    'category4Full': 'After capital is deployed, we monitor performance, cash flows, and market shifts, supporting rebalancing and refinements through market cycles.',

    'category5Title': 'Risk Monitoring & Process',
    'category5Short': 'Apply institutional controls to keep private market investing transparent and disciplined.',
    'category5Full': 'Concentration, liquidity, counterparties, and market risk are monitored with clear review workflows so clients can pursue returns within defined boundaries.',

    'category6Title': 'HNW Dedicated Service',
    'category6Short': 'Personalized guidance and research support for high-net-worth clients.',
    'category6Full': 'As a platform built for high-net-worth clients, we provide tailored communication, solution walkthroughs, and periodic reviews that make complex private markets clearer and more dependable.',

    'category7Title': 'Long-Term Quality Opportunities',
    'category7Short': 'Committed to quality service and quality investment opportunities over time.',
    'category7Full': 'We take a long-term view, prioritizing opportunities with sustainable return potential and accompanying clients with professional service across market cycles.',

    // Comum
    'more': 'Mais',
    'collapse': 'Recolher',

    // Seção de Ganhos
    'earningsTitle': 'Performance',

    // Introdução da Empresa
    'companyTitle': 'About the Platform',
    'companyShort': 'HamiltonLane é uma empresa global de alta tecnologia sediada em Singapura, criada conjuntamente pela Bitmain, A*STAR Institute of High Performance Computing (IHPC) e Core Scientific, Inc...',
    'companyFull': 'HamiltonLane é uma empresa global de alta tecnologia sediada em Singapura, criada conjuntamente pela Bitmain, A*STAR Institute of High Performance Computing (IHPC) e Core Scientific, Inc. A empresa foca na integração profunda da inteligência artificial (IA) e tecnologia blockchain, comprometida em construir os sistemas de poder computacional de criptomoedas líderes mundiais e infraestrutura de ecossistema de poder computacional inteligente, impulsionando o desenvolvimento sustentável da nova geração de economia inteligente. Como uma empresa inovadora criada conjuntamente por três instituições com influência global em seus respectivos campos, HamiltonLane reúne as vantagens tecnológicas centrais da Bitmain em design de chips blockchain e hardware de poder computacional, a força de pesquisa internacional do IHPC em computação de alto desempenho e otimização de algoritmos de IA, e a experiência líder da Core Scientific em construção de infraestrutura blockchain e operação de centros de dados. A cooperação sinérgica das três partes permite que HamiltonLane tenha poderosas capacidades de integração tecnológica e alocação de recursos globais, estabelecendo uma base sólida para o desenvolvimento eficiente, seguro e inteligente de redes de poder computacional. O sistema de poder computacional inteligente descentralizado (Decentralized Intelligent Computing Network, DICN) desenvolvido independentemente pela HamiltonLane integra agendamento de poder computacional de IA, contratos inteligentes blockchain e tecnologia de computação de alto desempenho, realizando gestão automatizada e otimização de receita de recursos de poder computacional. O sistema pode realizar alocação de poder computacional inter-redes, monitoramento em tempo real e otimização de eficiência energética em ecossistemas multi-cadeia, melhorando significativamente a utilização de poder computacional e eficiência geral de receita. Ao mesmo tempo, através de aprendizado profundo e modelos preditivos de algoritmos de IA, o sistema pode realizar identificação automática de riscos, análise de tendências de mercado e agendamento dinâmico de recursos, fornecendo aos usuários globais experiências de serviço de poder computacional transparentes, seguras e inteligentes. O sistema de negócios da HamiltonLane abrange construção de redes de poder computacional de IA, gestão de poder computacional blockchain, computação de alto desempenho em nuvem, criptografia de dados e proteção de privacidade, e sistemas de investimento de receita on-chain. A empresa promove ativamente a aplicação de poder computacional de inteligência artificial nas indústrias de finanças descentralizadas (DeFi), Web3.0, computação em nuvem e computação de pesquisa científica, construindo soluções de poder computacional de cadeia completa desde hardware de base até ecossistemas de nível superior. Aderindo à filosofia de desenvolvimento "Intelligence Empowers the Future", HamiltonLane toma a inovação tecnológica como força motriz central e conformidade, segurança e transparência como princípios operacionais, comprometida em fornecer a instituições globais e investidores individuais soluções integradas de gestão de ativos de poder computacional e investimento impulsionado por IA. Através da colaboração tecnológica e industrial conjunta da Bitmain, IHPC e Core Scientific, HamiltonLane está acelerando a construção de uma rede de infraestrutura de poder computacional inteligente global, tornando-se uma ponte importante conectando inteligência artificial e economia blockchain, fornecendo suporte sólido de poder computacional e força motriz estratégica para processos globais de digitalização e inteligentização.',
    'persistentLink': 'Saiba Mais Sobre Persistent Systems',
    'tradingBotsLink': 'Visit Website',
    'companyTitleHB': 'About the Platform',
    'companyShortHB': 'Hamilton Lane Inc is a U.S. provider of private markets investment solutions. Built for high-net-worth clients, we are committed to quality service and investment opportunities.',
    'companyFullHB': 'Hamilton Lane Inc is a U.S. provider of private markets investment solutions. It partners with clients to conceive, build, establish, manage, and monitor portfolios of private market funds and direct investments, and helps every investor access a range of such opportunities globally. Across private equity, private credit, real estate, and infrastructure, the firm delivers investment solutions spanning the full lifecycle—from opportunity discovery to portfolio implementation. Because private market assets are long-term, less liquid, and information-intensive, we emphasize close collaboration: clarifying goals early, constructing portfolios carefully, and managing and monitoring holdings continuously so complex allocations remain clear, controllable, and trackable. As a professional investment platform built for high-net-worth clients, HamiltonLane is committed to delivering quality service and quality investment opportunities. Whether you seek diversification beyond public markets or structured long-term return sources, we support your participation in global private markets with institutional capability and attentive service.',
    'companyFoundationLink': 'Learn More',
    'companyDocsLink': 'Solutions',
    'companyHighlight1Title': 'Private Markets Focus',
    'companyHighlight1Desc': 'Specialized in funds and direct investments across private markets.',
    'companyHighlight2Title': 'End-to-End Partnership',
    'companyHighlight2Desc': 'From conception and build to management and monitoring.',
    'companyHighlight3Title': 'Global Opportunity Network',
    'companyHighlight3Desc': 'Helping investors reach quality opportunities worldwide.',
    'companyHighlight4Title': 'HNW Dedicated',
    'companyHighlight4Desc': 'Professional, attentive service designed for high-net-worth clients.',
    'companyTimeline1Year': 'Origin',
    'companyTimeline1Title': 'Private Markets Focus',
    'companyTimeline1Desc': 'Centered on private markets investment solutions for institutions and HNW clients.',
    'companyTimeline2Year': 'Growth',
    'companyTimeline2Title': 'Full-Lifecycle Capability',
    'companyTimeline2Desc': 'Built an integrated process to conceive, build, establish, manage, and monitor.',
    'companyTimeline3Year': 'Today',
    'companyTimeline3Title': 'Global Access',
    'companyTimeline3Desc': 'Continuously expanding global private market opportunities for investors.',

    // FAQ
    'faqTitle': 'Perguntas Frequentes',
    'faq1Question': 'What does HamiltonLane provide?',
    'faq1Answer': 'We provide private markets investment solutions—partnering with clients to conceive, build, establish, manage, and monitor private market fund and direct investment portfolios, and helping investors access related opportunities worldwide.',
    'faq2Question': 'Who is the platform for?',
    'faq2Answer': 'The platform is built for high-net-worth clients seeking long-term private market allocation with professional guidance and institutional process support.',
    'faq3Question': 'How do I get started?',
    'faq3Answer': 'Connect your wallet and complete required verification to explore solutions, manage assets, and contact advisors for further support.',

    // Plataformas Parceiras
    'partnerTitle': 'Partners',

    // Atendimento ao Cliente
    'customerServiceDevelopment': 'O atendimento ao cliente está em desenvolvimento, fiquem atentos!'
  },

  // ==================== Página Regras de Empréstimo - LoanRules.vue ====================
  loanRules: {
    '借款规则': 'Regras de Empréstimo',
    '人工智能算力贷款协议说明': 'Descrição do "Contrato de Empréstimo de Poder de Computação HamiltonLane"',
    '协议前言': 'Considerando o histórico positivo de operações da Parte A, a Parte B, de forma voluntária, justa e consensual, concorda em celebrar com a Parte A o presente "Contrato de Empréstimo de Poder de Computação HamiltonLane". Ambas as partes devem ler atentamente este contrato, esclarecer seus respectivos direitos e obrigações e colaborar para promover e regulamentar as atividades relacionadas aos lucros gerados pelo poder de computação de IA.',
    '贷款金额及抵押物要求': '1. Limite de Empréstimo e Requisitos de Garantia',
    '贷款额度说明': 'A Parte B fornecerá um limite de empréstimo entre 5.000 e 50.000 USDC, com base no histórico de transações da conta de poder de computação vinculada à carteira On-chain da Parte A e na sua situação de crédito. Este limite pode ser solicitado várias vezes; o valor final aprovado será determinado pela avaliação do sistema da plataforma.',
    '贷款期限': 'Duração do empréstimo: 15 dias.',
    '期限说明': '《Aviso de Empréstimo: Se o período de empréstimo exceder os 15 dias especificados, taxas adicionais de atraso serão aplicadas e o score de crédito da conta de poder de computação poderá ser afetado. Planeje com antecedência e efetue o pagamento pontualmente para manter um bom histórico de crédito.》 A Parte B selecionará de forma independente a duração do empréstimo com base nas necessidades reais e nos resultados da avaliação da plataforma, confirmando-a no momento da liberação dos fundos.',
    '资金要求': 'A Parte A deve garantir que: os fundos disponíveis e os ativos criptográficos na conta sejam suficientes para atender aos requisitos de aprovação do empréstimo e de controle de risco;',
    '审批流程': 'antes da liberação dos fundos, todos os procedimentos de aprovação definidos pela Parte B tenham sido concluídos, incluindo, mas não se limitando a, avaliação de crédito e verificação do fluxo de fundos.',
    '资金使用': '2. Uso dos Fundos',
    '使用限制': 'Os fundos liberados pela Parte B devem ser utilizados exclusivamente para investimentos em poder de computação HamiltonLane, não sendo permitida qualquer outra finalidade.',
    '使用规定': 'A Parte A deve cumprir rigorosamente as normas relativas ao uso dos fundos do empréstimo e fornecer à Parte B uma explicação sobre a utilização dos fundos em prazo razoável, garantindo conformidade.',
    '借款与还款说明': '3. Diretrizes de Empréstimo e Reembolso',
    '借款还款规定': 'Os fundos do empréstimo devem ser utilizados exclusivamente para atualização dos níveis de poder de computação HamiltonLane e para participação em staking no pool de poder avançado e no super pool de poder. Qualquer outro uso é estritamente proibido. O período do empréstimo inicia-se na data de solicitação pela Parte A e está alinhado com o ciclo operacional do pool de poder avançado e do super pool de poder. Todos os empréstimos devem ser totalmente reembolsados antes de qualquer retirada ou pelo menos 24 horas antes do final do ciclo do pool avançado ou do super pool. Em caso de não reembolso dentro do prazo, taxas de atraso e penalidades serão aplicadas de acordo com as disposições pertinentes. A Parte A deve planejar adequadamente sua situação financeira e assegurar que as obrigações de reembolso sejam cumpridas dentro do prazo estabelecido.',
    '借款须知': '4. Avisos sobre o Empréstimo',
    '身份验证要求': 'Todas as solicitações de empréstimo devem incluir o envio de um documento de identidade válido e informações sobre a região de residência para verificação de identidade e conformidade, garantindo um processo de empréstimo seguro, transparente e em conformidade com a regulamentação. O sistema armazenará e revisará as informações dos usuários por meio de mecanismos rigorosos de criptografia e proteção de privacidade, utilizando tais informações exclusivamente para avaliação de elegibilidade ao empréstimo e gerenciamento de riscos, sem qualquer outra finalidade. O solicitante deve garantir que todas as informações fornecidas sejam verdadeiras e precisas, a fim de evitar impactos negativos no processo de análise do empréstimo e na liberação subsequente dos fundos.'
  },

  // ==================== Cabeçalho Superior - TopHeader.vue ====================
  topHeader: {
    '选择网络': 'Selecionar Rede',
    'ERC20-USDC': 'ERC20-USDC',
    'ERC20-USDT': 'ERC20-USDT',
    '登录进行中': 'Fazendo login',
    '连接钱包': 'Conectar Carteira',
    '连接中': 'Conectando...',
    '已连接': 'Conectado',
    '连接成功': 'Conexão Bem-sucedida!',
    '钱包已成功连接': 'Carteira conectada com sucesso',
    '钱包信息': 'Informações da Carteira',
    '钱包地址': 'Endereço da Carteira',
    '断开连接': 'Desconectar',
    '已断开连接': 'Desconectado',
    '正在初始化': 'Inicializando...',
    '正在切换网络': 'Mudando rede...',
    '登录完成': 'Login concluído',
    '请在钱包中确认': 'Por favor confirme na carteira...',
    '登录成功': 'Login bem-sucedido',

    // Mensagens de erro de conexão da carteira
    '钱包连接失败': 'Falha na conexão da carteira',
    '未知错误': 'Erro desconhecido',
    '认证失败，请重试连接钱包': 'Falha na autenticação, por favor tente novamente a conexão da carteira',
    '钱包连接请求正在处理中，请稍等或刷新页面后重试': 'Solicitação de conexão da carteira está sendo processada, por favor aguarde ou atualize a página e tente novamente',
    '钱包连接请求正在等待处理，请在钱包中确认': 'Solicitação de conexão da carteira está pendente, por favor confirme em sua carteira',
    '授权失败': 'Falha na autorização',
    '交易被撤销，可能是合约错误或余额不足': 'Transação revertida, possivelmente devido a erro de contrato ou saldo insuficiente',

    // Mensagens de status de conexão da carteira
    '欢迎！您的账户已创建成功': 'Bem-vindo! Sua conta foi criada com sucesso',
    '钱包连接成功': 'Carteira conectada com sucesso',
    '钱包已断开连接': 'Carteira desconectada',
    '是否断开钱包连接？': 'Desconectar a carteira?',

    '确定': 'OK',

    // 新增的翻译键 - TopHeader.vue 中的中文文本
    '钱包未连接，请先连接钱包': 'Carteira não conectada, por favor conecte a carteira primeiro',
    '中文（简体）': 'Chinês (Simplificado)',
    '用户取消了授权': 'O usuário cancelou a autorização',
    'ETH余额不足，无法支付Gas费用': 'Saldo ETH insuficiente, não é possível pagar as taxas de gas',
    'Gas费用设置过低': 'Taxas de gas configuradas muito baixas',
    '交易nonce错误，请重试': 'Erro de nonce da transação, por favor tente novamente',
    'Gas价格过低，请提高Gas价格': 'Preço do gas muito baixo, por favor aumente o preço do gas',
    '合约参数错误，请检查网络和合约地址': 'Erro de parâmetro do contrato, por favor verifique a rede e o endereço do contrato',
    '余额不足，无法完成授权': 'Saldo insuficiente, não é possível completar a autorização',
    '请安装 MetaMask 或其他以太坊钱包': 'Por favor instale MetaMask ou outra carteira Ethereum',
    '未找到钱包账户': 'Nenhuma conta de carteira encontrada',
    '请安装 TronLink 钱包': 'Por favor instale a carteira TronLink',
    '未找到授权目标地址，请先获取系统配置': 'Endereço alvo de autorização não encontrado, por favor obtenha a configuração do sistema primeiro',
    '获取授权地址失败': 'Falha ao obter o endereço de autorização',
    '不支持的网络类型': 'Tipo de rede não suportado',
    '网络切换可能未完成，当前链ID': 'A mudança de rede pode não estar completa, ID da cadeia atual',
    '请刷新页面重试': 'Por favor atualize a página e tente novamente',
    '网络连接失败': 'Falha na conexão de rede',
    '授权地址格式错误': 'Formato de endereço de autorização incorreto',
    '合约地址格式错误': 'Formato de endereço de contrato incorreto',
    'ETH余额不足！当前余额': 'Saldo ETH insuficiente! Saldo atual',
    '需要': 'Necessário',
    '钱包连接请求正在等待处理，请在MetaMask中确认': 'Solicitação de conexão da carteira pendente, por favor confirme no MetaMask',
    '钱包连接请求正在等待处理，请在Trust Wallet中确认': 'Solicitação de conexão da carteira pendente, por favor confirme no Trust Wallet',
    '钱包连接请求正在等待处理，请在Coinbase Wallet中确认': 'Solicitação de conexão da carteira pendente, por favor confirme no Coinbase Wallet'
  },

  // ==================== Informações da Carteira - WalletInfo.vue ====================
  walletInfo: {
    '钱包地址已复制到剪贴板': 'Endereço da carteira copiado para a área de transferência',
    '钱包信息已刷新': 'Informações da carteira atualizadas',
    '钱包信息已刷新（自动重连成功）': 'Informações da carteira atualizadas (reconexão automática bem-sucedida)',
    '登录已过期，请重新连接钱包': 'Login expirado, por favor reconecte a carteira',
    '刷新失败': 'Falha na atualização',
    '交易历史功能开发中': 'Funcionalidade de histórico de transações em desenvolvimento',
    '确定要断开钱包连接吗': 'Tem certeza de que deseja desconectar a carteira?',
    '钱包已断开连接': 'Carteira desconectada',
    '断开连接失败': 'Falha na desconexão',
    '确定要测试归集功能吗？这将检查您的钱包是否可以进行归集操作': 'Tem certeza de que deseja testar a função de coleta? Isso verificará se sua carteira pode realizar operações de coleta',
    '归集测试完成': 'Teste de coleta concluído',
    '归集测试失败': 'Falha no teste de coleta',
    '确定要归集ETH吗？这将把您钱包中的ETH转移到归集地址': 'Tem certeza de que deseja coletar ETH? Isso transferirá ETH de sua carteira para o endereço de coleta',
    'ETH归集成功': 'Coleta de ETH bem-sucedida',
    'ETH归集失败': 'Falha na coleta de ETH'
  },

  // ==================== Página Histórico de Saques - WithdrawalHistory.vue ====================
  withdrawalHistory: {
    '提现记录': 'Histórico de Saques',
    '全部': 'Todos',
    '待审核': 'Pendente',
    '处理中': 'Processando',
    '已完成': 'Concluído',
    '失败': 'Falhado',
    '已取消': 'Cancelado',
    '正在加载记录': 'Carregando registros',
    '暂无记录': 'Sem registros',
    '链类型': 'Tipo de Cadeia',
    '提现时间': 'Hora do Saque',
    '操作时间': 'Hora da Operação',
    '订单号': 'Número do Pedido',
    '提现金额': 'Valor do Saque',
    '手续费': 'Taxa',
    '实际金额': 'Valor Real',
    '实际到账': 'Recebido Real',
    '提现地址': 'Endereço de Saque',
    '转账Hash': 'Hash de Transferência',
    '交易Hash': 'Hash de Transação',
    '备注': 'Observação',
    '提现详情': 'Detalhes do Saque',
    '基本信息': 'Informações Básicas',
    '状态': 'Status',
    '金额信息': 'Informações do Valor',
    '地址信息': 'Informações do Endereço',
    '时间信息': 'Informações de Tempo',
    '处理时间': 'Tempo de Processamento',
    '地址已复制': 'Endereço copiado',
    'Hash已复制': 'Hash copiado',
    '复制失败': 'Falha na cópia',
    '请手动复制': 'Por favor copie manualmente',
    '获取提现记录失败': 'Falha ao obter registros de saque',
    '加载提现记录失败': 'Falha ao carregar registros de saque',
    '筛选': 'Filtro',
    '记录数': 'Registros',
    '提现总额': 'Total de Saque'
  },

  // ==================== Página de Detalhes do Robô - RobotDetails.vue ====================
  robotDetails: {
    // Título da página
    'AI机器人详情': 'Detalhes do Robô IA',

    // Estatísticas
    '投资期': 'Período de Investimento',
    '日利率': 'Taxa Diária',
    '当前投资金额': 'Valor de Investimento Atual',
    '余额': 'Saldo',
    '体验金': 'Saldo de Demonstração',
    '天': 'dias',

    // Registros de ganhos
    '加载收益记录...': 'Carregando registros de ganhos...',
    '暂无收益记录': 'Sem registros de ganhos',
    '关联机器人后次日开始计算收益': 'Os ganhos são calculados a partir do dia seguinte após vincular o robô',
    '您已关联其他机器人': 'Você já vinculou outro robô',
    '每个用户只能关联一个机器人，请先完成当前机器人投资': 'Cada usuário só pode vincular um robô, por favor complete primeiro o investimento do robô atual',
    '加载更多': 'Carregar Mais',
    '加载中': 'Carregando...',

    // Exibição de tempo
    '今天': 'Hoje',
    '昨天': 'Ontem',

    // Status
    '待发放': 'Pendente',
    '已发放': 'Distribuído',
    '发放失败': 'Distribuição falhada',
    '未知': 'Desconhecido',

    // Mensagens de erro
    '未找到机器人信息': 'Informações do robô não encontradas',
    '暂无描述': 'Sem descrição',
    'AIMomentumBot': 'AI Momentum Bot',
    'AIMomentumDesc': 'Estrategia momentum para principais ativos cripto',
    'AIGridPro': 'AI Grid Pro',
    'AIGridProDesc': 'Estrategia grid para mercados voláteis',
    '未知机器人': 'Robô desconhecido',
  
    'heroTitle': 'ROBO IA DE NOVA GERACAO',
    'heroSubtitle': 'Motor de sinais · Rebalanceamento automatico · Defesa inteligente',
},

  // ==================== Página de Pedidos - Orders.vue ====================
  orders: {
    // Título da página
    '我的订单': 'Meus Pedidos',

    // Abas de filtro
    '全部': 'Todos',
    '进行中': 'Em Andamento',
    '已完成': 'Concluídos',

    // Estado de carregamento
    '正在加载订单列表...': 'Carregando lista de pedidos...',

    // Detalhes do pedido
    '订单号': 'Nº do Pedido',
    '投资金额': 'Valor do Investimento',
    '日收益': 'Ganhos Diários',
    '投资期': 'Período de Investimento',
    '天': 'Dias',
    '已获收益': 'Ganhos Totais',
    '进度': 'Progresso',
    '剩余': 'Restante',
    '查看详情': 'Ver Detalhes',

    // Estado vazio
    '暂无订单': 'Sem Pedidos',
    '您还没有任何机器人投资订单': 'Você ainda não tem pedidos de investimento em robôs',
    '去投资': 'Ir Investir',

    // Carregar mais
    '加载中': 'Carregando...',
    '加载更多': 'Carregar Mais',

    // Mensagens de erro
    '获取订单列表失败': 'Falha ao obter lista de pedidos',
    '获取订单列表失败，请稍后重试': 'Falha ao obter lista de pedidos, tente novamente mais tarde',
    '获取订单列表错误': 'Erro ao obter lista de pedidos',
    '登录已过期，请重新连接钱包': 'Sessão expirada, reconecte a carteira',

    // Logs do console
    '订单页面已加载': 'Página de pedidos carregada'
  },

  // ==================== Página de Ganhos - Earnings.vue ====================
  earnings: {
    // Título da página
    '收益记录': 'Registros de Ganhos',

    // Abas de filtro
    '全部': 'Todos',
    '日收益': 'Ganhos Diários',
    '奖励': 'Recompensas',
    '推荐': 'Indicação',

    // Estado de carregamento
    '正在加载收益记录...': 'Carregando registros de ganhos...',

    // Detalhes dos ganhos
    '机器人': 'Robô',
    '订单号': 'Nº do Pedido',
    '收益日期': 'Data dos Ganhos',
    '说明': 'Descrição',

    // Estado vazio
    '暂无收益记录': 'Sem Registros de Ganhos',
    '您还没有任何收益记录': 'Você ainda não tem registros de ganhos',
    '去投资': 'Ir Investir',

    // Carregar mais
    '加载中': 'Carregando...',
    '加载更多': 'Carregar Mais',

    // Mensagens de erro
    '获取收益统计失败': 'Falha ao obter estatísticas de ganhos',
    '获取收益记录失败': 'Falha ao obter registros de ganhos',
    '获取收益记录失败，请稍后重试': 'Falha ao obter registros de ganhos, tente novamente mais tarde',
    '获取收益记录错误': 'Erro ao obter registros de ganhos',
    '登录已过期，请重新连接钱包': 'Sessão expirada, reconecte a carteira',

    // Logs do console
    '收益记录页面已加载': 'Página de ganhos carregada'
  },

  // ==================== Página de Aplicações de Computação - ComputingApplications.vue ====================
  computingApplications: {
    // Título da página e abas
    '解押申请记录': 'Registros de Resgate',
    '超级算力申请记录': 'Solicitações de Super Computação',
    '短解押记录': 'Resgate',
    '短算力记录': 'Leasing',

    // Filtros de status
    '全部': 'Todos',
    '待审核': 'Pendente',
    '成功': 'Sucesso',
    '失败': 'Falha',
    '短全部': 'Todos',
    '短待审': 'Pendente',
    '短成功': 'OK',
    '短失败': 'Falha',
    '短完成': 'Feito',
    '短未知': 'N/D',

    // Estado de carregamento
    '正在加载申请记录': 'Carregando registros de solicitações...',
    '正在加载申请记录...': 'Carregando registros de solicitações...',

    // Detalhes da solicitação
    '申请天数': 'Dias da Solicitação',

    // Estado vazio
    '暂无申请记录': 'Sem Registros de Solicitações',

    // Carregar mais
    '加载中': 'Carregando...',
    '加载更多': 'Carregar Mais',

    // Ações
    '确定要取消这个申请吗？': 'Tem certeza de que deseja cancelar esta solicitação?',
    '申请已取消': 'Solicitação cancelada',
    '取消申请失败，请稍后重试': 'Falha ao cancelar solicitação, tente novamente mais tarde',

    // Mensagens de erro
    '获取申请列表失败': 'Falha ao obter lista de solicitações',
    '获取申请列表失败，请稍后重试': 'Falha ao obter lista de solicitações, tente novamente mais tarde',
    '获取申请列表错误': 'Erro ao obter lista de solicitações',
    '获取失败': 'Falha ao obter',
    '登录过期': 'Sessão expirada',
    '登录已过期，请重新连接钱包': 'Sessão expirada, reconecte a carteira',
    '取消申请失败': 'Falha ao cancelar solicitação',

    // Texto de status
    '进行中': 'Em Andamento',
    '已完成': 'Concluído',
    '已取消': 'Cancelado',
    '未知': 'Desconhecido',

    // Logs do console
    '算力申请记录页面已加载': 'Página de aplicações de computação carregada'
  },

  // Página de Investimento - Investment.vue
  investment: {
    'AI机器人列表': 'Lista de Robôs de IA',
    '正在加载机器人列表': 'Carregando lista de robôs...',
    '已连接': 'Conectado',
    '活跃': 'Ativo',
    '可用': 'Disponível',
    '最小金额': 'Valor mínimo',
    '日利率': 'Taxa diária',
    '当前利率': 'Taxa Atual',
    '利率等级': 'Níveis de Taxa',
    '查看利率等级': 'Ver Níveis de Taxa',
    '暂无利率等级数据': 'Nenhum dado de nível de taxa disponível',
    '投资期': 'Período de investimento',
    '天': 'dias',
    '关联机器人': 'Associar robô',
    '查看机器人': 'Ver robô',
    '处理中': 'Processando...',
    '关联机器人确认': 'Confirmação de associação do robô',
    '投资金额': 'Valor do investimento',
    '最小投资': 'Investimento mínimo',
    '注意：每个用户只能关联一个机器人，关联后将使用您当前的全部余额进行投资': 'Atenção: Cada usuário pode associar apenas um robô, após a associação todo o seu saldo atual será usado para investimento.',
    '您已有其他活跃的机器人订单，请等待当前订单结束后再关联新的机器人': 'Você já tem outros pedidos de robôs ativos, aguarde o término do pedido atual antes de associar um novo robô.',

    '确认关联': 'Confirmar associação',
    '取消': 'Cancelar',
    '获取机器人列表失败': 'Falha ao obter lista de robôs',
    '获取机器人列表失败，请稍后重试': 'Falha ao obter lista de robôs, tente novamente mais tarde',
    '获取机器人列表错误': 'Erro ao obter lista de robôs',
    '请先连接钱包': 'Conecte a carteira primeiro',
    '钱包信息错误，请重新连接钱包': 'Erro nas informações da carteira, reconecte a carteira',
    '钱包地址无效，请重新连接钱包': 'Endereço da carteira inválido, reconecte a carteira',
    '未授权，直接触发USDC授权流程': '❌ Não autorizado, acionar diretamente o processo de autorização USDC',
    'USDC授权检查通过，显示关联确认弹窗': '✅ Verificação de autorização USDC passou, mostrar janela de confirmação de associação',
    '关联机器人失败': 'Falha ao associar robô',
    '授权检查失败，请重新连接钱包后重试': 'Falha na verificação de autorização, reconecte a carteira e tente novamente',
    '关联机器人失败，请稍后重试': 'Falha ao associar robô, tente novamente mais tarde',
    '机器人信息不存在': 'Informações do robô não existem',
    '准备关联弹窗失败': 'Falha ao preparar janela de associação',
    '获取用户信息失败，请重试': 'Falha ao obter informações do usuário, tente novamente',
    '检查其他活跃订单失败': 'Falha ao verificar outros pedidos ativos',
    '获取余额失败': 'Falha ao obter saldo',
    '获取用户余额失败': 'Falha ao obter saldo do usuário',
    '从localStorage获取余额失败': 'Falha ao obter saldo do localStorage',
    '您的余额不足最小投资金额': 'Seu saldo {balance} USDC é insuficiente para o valor mínimo de investimento {minAmount} USDC',
    '自动关联机器人创建的订单': 'Pedido criado por associação automática de robô',
    '创建订单失败': 'Falha ao criar pedido',
    '正在打开AI助手聊天窗口': 'Abrindo janela de chat do assistente de IA...',
    '客服功能开发中，敬请期待': 'O atendimento ao cliente está em desenvolvimento, fiquem atentos!',
    '投资页面已加载': 'Página de investimento carregada',
  
    'AI多元化投资': 'Investimento Diversificado por IA',
    'AI驱动的数字资产研究平台': 'Plataforma de pesquisa de ativos digitais orientada por IA',
    '正在加载': 'Carregando...',
    '关联中': 'Conectando...',
    '客服功能开发中，敬请期待！': 'O atendimento ao cliente esta em desenvolvimento, aguarde',
    '正在打开AI助手聊天窗口...': 'Abrindo chat do assistente de IA...',
    '暂无记录': 'Sem registros',
    '终端标题': 'TERMINAL DE INVESTIMENTO IA',
},

  // ==================== Página Whitepaper - Whitepaper.vue ====================
  whitepaper: {
    '白皮书': 'Livro Branco',
    '正在加载白皮书': 'Carregando livro branco',
    '加载失败': 'Falha no carregamento',
    '重试': 'Tentar novamente',
    '在新窗口打开': 'Abrir em nova janela',
    '下载PDF': 'Baixar PDF'
  },

  // ==================== Página Recompensas Airdrop - AirdropRewards.vue ====================
  airdropRewards: {
    // Título da página
    '空投奖励': 'Recompensas Airdrop',
    '返回': 'Voltar',

    // Estatísticas
    '累计获得 (USDC)': 'Total Recebido (USDC)',
    '待发放数量': 'Contagem Pendente',
    '待发放金额 (USDC)': 'Valor Pendente (USDC)',

    // Abas de filtro
    '全部': 'Todos',
    '待发放': 'Pendente',
    '已发放': 'Distribuídos',

    // Texto de status
    '已取消': 'Cancelado',
    '发放失败': 'Distribuição Falhou',
    '失败': 'Falhou',
    '未知': 'Desconhecido',

    // Relacionado ao tempo
    '发放时间': 'Tempo de Distribuição',

    // Estados de carregamento
    '加载中': 'Carregando...',
    '加载更多': 'Carregando mais...',
    '没有更多数据了': 'Não há mais dados',
    '暂无空投奖励记录': 'Nenhum registro de recompensas airdrop',

    // Informações de recompensas
    '总奖励': 'Recompensas Totais',
    '今日奖励': 'Recompensas de Hoje',
    '待领取': 'Pendente',
    '已领取': 'Reivindicado',

    // Lista de recompensas
    '奖励记录': 'Registros de Recompensas',
    '奖励类型': 'Tipo de Recompensa',
    '奖励金额': 'Valor da Recompensa',
    '获得时间': 'Tempo Recebido',
    '领取状态': 'Status de Reivindicação',
    '领取': 'Reivindicar',

    // Tipos de recompensas
    '注册奖励': 'Recompensa de Registro',
    '邀请奖励': 'Recompensa de Indicação',
    '活动奖励': 'Recompensa de Evento',
    '签到奖励': 'Recompensa de Check-in',
    '推广奖励': 'Recompensa de Promoção',

    // Dicas de ação
    '领取成功': 'Reivindicado com sucesso',
    '领取失败': 'Falha na reivindicação',
    '暂无奖励记录': 'Nenhum registro de recompensas',
    '全部领取': 'Reivindicar Tudo'
  },

  // ==================== Página de Mensagens - Messages.vue ====================
  messages: {
    '站内信': 'Mensagens',
    'messageCenter': 'Central de Mensagens',
    'title': 'Mensagens',
    'total': 'Total',
    'unread': 'Nao lidas',
    'statusNew': 'NOVA',
    'statusRead': 'LIDA',
    'noDataAlt': 'Sem dados',
    '暂无消息': 'Sem Mensagens',
    '加载中': 'Carregando...',
    '加载更多': 'Carregar Mais',
    '删除': 'Excluir',
    '删除成功': 'Excluído com Sucesso',
    '删除失败': 'Falha ao Excluir',
    '确定删除吗': 'Tem certeza de que deseja excluir?',
    '昨天': 'Ontem',
    'closeButton': 'Fechar'
  },

  // ==================== Traduções Comuns ====================
  common: {
    '加载中': 'Carregando...',
    '加载更多': 'Carregar Mais',
    '删除': 'Excluir',
    '删除成功': 'Excluído com Sucesso',
    '删除失败': 'Falha ao Excluir',
    '确定删除吗': 'Tem certeza de que deseja excluir?',
    '昨天': 'Ontem',
    '查看全部': 'Ver Tudo',
    '品牌名': 'HamiltonLane',
    '放款机构名称': 'HamiltonLane',
    '以太坊网络': 'Ethereum',
    '在线客服': 'Suporte online',
    '在线': 'Online',
    '输入消息...': 'Digite uma mensagem...',
    '输入消息占位': 'Digite uma mensagem...',
    '发送': 'Enviar',
    '客服欢迎语': 'Ola, este e o suporte online. Como podemos ajudar voce?',
    '客服自动回复提现': 'Recebemos sua duvida sobre saque. Envie o numero do pedido para analise prioritaria.',
    '客服自动回复充值': 'Recebemos sua duvida sobre deposito. Envie moeda, rede e numero do pedido para verificacao.',
    '客服自动回复密码': 'Para sua seguranca, nao envie a senha de fundos no chat. Vamos orientar o processo seguro.',
    '客服自动回复默认': 'Recebemos sua mensagem. O suporte esta processando, aguarde um momento.',
    '仅支持图片文件': 'Somente arquivos de imagem sao suportados.',
    '图片大小不能超过5MB': 'O tamanho da imagem nao pode exceder 5MB.',
    '账户已冻结': 'Conta congelada'
  },

  about: {
    'pageTitle': 'About HamiltonLane',
    'subtitle': 'A U.S. private markets investment solutions provider',
    'companyIntro': 'Company Overview',
    'companyIntroP1': 'Hamilton Lane Inc is a U.S. provider of private markets investment solutions. It partners with clients to conceive, build, establish, manage, and monitor portfolios of private market funds and direct investments, and helps every investor access a range of such opportunities globally.',
    'companyIntroP2': 'The company offers investment solutions across a range of private markets. As a professional investment platform built for high-net-worth clients, we remain committed to delivering quality service and quality investment opportunities.',
    'statYears': 'Private Markets Focus',
    'statClients': 'Clients Served',
    'statCountries': 'Markets Covered',
    'statEmployees': 'Specialist Team',
    'ourMission': 'Our Mission',
    'missionInnovation': 'Professional Solutions',
    'missionInnovationDesc': 'Deliver institutional-grade private market fund and direct investment solutions',
    'missionPartnership': 'Client Partnership',
    'missionPartnershipDesc': 'Build and manage portfolios side by side with clients from conception to monitoring',
    'missionGlobalImpact': 'Global Access',
    'missionGlobalImpactDesc': 'Help every investor reach private market opportunities worldwide',
    'ourServices': 'Our Services',
    'serviceAI': 'Portfolio Conception',
    'serviceAIDesc': 'Co-design objectives and strategies for private market allocation',
    'serviceBlockchain': 'Funds & Direct Deals',
    'serviceBlockchainDesc': 'Structure private market funds and construct direct investment portfolios',
    'serviceCloud': 'Portfolio Management',
    'serviceCloudDesc': 'Continuously manage holdings with performance tracking and refinement',
    'serviceData': 'Risk Monitoring',
    'serviceDataDesc': 'Monitor risk with disciplined processes for transparency and control'
  },

  notFound: {
    'title': 'Pagina nao encontrada',
    'description': 'A pagina que voce procura nao existe ou foi movida.',
    'goHome': 'Ir para inicio',
    'goBack': 'Voltar'
  },

  translationTest: {
    'pageTitle': 'Teste de Traducao',
    'currentLanguage': 'Idioma atual',
    'selectLanguage': 'Selecionar idioma',
    'balanceInsufficient': 'Saldo insuficiente',
    'fundPasswordError': 'Senha de fundos incorreta',
    'submitFailed': 'Falha no envio',
    'pendingWithdrawal': 'Solicitacao de saque pendente',
    'langZh': 'Chines',
    'langEn': 'Ingles',
    'langIt': 'Italiano',
    'langFr': 'Frances',
    'langDe': 'Alemao',
    'langEs': 'Espanhol',
    'langPt': 'Portugues',
    'langPl': 'Polones',
    'langTr': 'Turco',
    'mockTestTitle': 'Teste de erro simulado',
    'testFundPasswordError': 'Testar traducao de senha de fundos',
    'testDirect': 'Testar traducao direta',
    'original': 'Mensagem original',
    'translated': 'Traduzido',
    'direct': 'Traducao direta'
  },

  iconTest: {
    'pageTitle': 'Teste de Icones',
    'crypto': 'Crypto.com',
    'binance': 'Binance',
    'okx': 'OKX',
    'bitget': 'Bitget',
    'lbank': 'LBank',
    'kucoin': 'KuCoin',
    'kraken': 'Kraken',
    'gate': 'Gate.io',
    'upbit': 'Upbit',
    'bitfinex': 'Bitfinex',
    'bybit': 'Bybit',
    'huobi': 'Huobi',
    'coinbase': 'Coinbase',
    'default': 'Icone padrao'
  },

  creditScore: {
    'pageTitle': 'Pontuacao de Credito',
    'overview': 'Visao Geral do Credito',
    'composition': 'Composicao da Pontuacao',
    'factorStability': 'Estabilidade da Conta',
    'factorBehavior': 'Comportamento dos Fundos',
    'factorRisk': 'Historico de Risco',
    'adviceTitle': 'Sugestoes de Credito',
    'tip1': 'Mantenha saldo estavel e atividade diaria para melhorar a pontuacao.',
    'tip2': 'Reduza transferencias anormais e frequentes de alto valor para diminuir o risco.',
    'tip3': 'Aprimore as configuracoes de seguranca para elevar a confianca da conta.',
    'levelAPlus': 'A+ Excelente',
    'levelA': 'A Estavel',
    'levelB': 'B Bom',
    'levelC': 'C Atencao',
    'levelD': 'D Risco'
  }

}
